module.exports = __webpack_public_path__ + "static/ddd-diagram-d413633478d2af6562714f313d5dc9ee.svg";